module.exports = __webpack_public_path__ + "static/rabbit3-ee56267e6d43556957c8e8c20cbb4017.png";